import axios from 'axios'

axios.get(`/gv.txt?t=${Date.now()}`).then((response) => {
  let lastUserAction = Date.now();
  setInterval(() => {
    if (Date.now() - lastUserAction < 60000) return;
    axios.get(`/gv.txt?t=${Date.now()}`).then((response2) => {
      if (response.data !== response2.data) window.location = window.location;
    })
  }, 30000);
  document.body.addEventListener('mousemove', () => (lastUserAction = Date.now()));
});



// WEBPACK FOOTER //
// ./src/helpers/versionChecker.js